import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertV2 } from 'components/atoms/AlertV2';
import { Button } from 'components/atoms/Button';
import { PeppolColoredIcon } from 'utils/icons/figmaIcons';
import useCustomNavigate from 'hooks/useCustomeNavigate';
import { AppBannersContext } from 'contexts/AppBannersProvider/context';
import { BANNERS_STORAGE_KEYS } from 'contexts/AppBannersProvider/helpers';
import PeppolHelper from 'components/molecules/PeppolHelper.component';
import layoutContext from 'components/organisms/Layout/layoutContext';
import { isMobile, isTablet } from 'react-device-detect';
import {
  WEBAPP_PEPPOL_ACCOUNTANTREGISTERED_CLICKEDCOOL,
  WEBAPP_PEPPOL_ACCOUNTANTREGISTERED_CLICKEDUNREGISTER,
} from 'utils/amplitude/events/settings.amplitude';

const PeppolAccountantRegisteredBanner: FC = () => {
  const { t } = useTranslation();
  const navigate = useCustomNavigate();
  const { dismissBanner } = useContext(AppBannersContext);
  const layout = useContext(layoutContext);

  const isMobileOrTablet = isMobile || isTablet;

  const handleDismiss = () => {
    dismissBanner(
      BANNERS_STORAGE_KEYS.PEPPOL_ACCOUNTANT_REGISTERED_DISMISS_KEY,
    );
  };

  return (
    <div
      className="fixed z-[49] w-full md:w-[50%] right-4 top-4"
      style={{ left: isMobileOrTablet ? 0 : layout.sidebarArea * 2 }}
    >
      <AlertV2
        type="information"
        variant="filled"
        size="large"
        icon={PeppolColoredIcon}
        title={t('peppol.accountant_registered.title')}
        actions={
          <div className="flex gap-1 items-center flex-wrap">
            <Button
              color="bank"
              structure="text"
              className="text-sm !text-[#2563EB] underline"
              tracingEvent={WEBAPP_PEPPOL_ACCOUNTANTREGISTERED_CLICKEDCOOL}
              onClick={handleDismiss}
            >
              {t('peppol.accountant_registered.cool_thanks')}
            </Button>
            <span className="text-primary-400">∙</span>
            <PeppolHelper
              trigger={(openModal) => (
                <Button
                  color="bank"
                  structure="text"
                  className="text-sm !text-[#60A5FA] underline"
                  onClick={openModal}
                >
                  {t('peppol.accountant_registered.learn_more')}
                </Button>
              )}
            />
            <span className="text-primary-400">∙</span>
            <Button
              color="bank"
              structure="text"
              className="text-sm !text-[#60A5FA] underline"
              tracingEvent={
                WEBAPP_PEPPOL_ACCOUNTANTREGISTERED_CLICKEDUNREGISTER
              }
              onClick={() => {
                navigate('/settings/peppol');
                handleDismiss();
              }}
            >
              {t('peppol.accountant_registered.unregister')}
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default PeppolAccountantRegisteredBanner;
